import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminLeadPartners = lazy(() => import("@/pages/admin/AdminLeadPartners"));

export const Route = createFileRoute("/admin/leadpartners")({
  component: () => <AdminLeadPartners />,
});
